import CONFIG from '@/configs/config'
import { Get, Post } from '@/utils/RequestService'

var apiUrl = CONFIG.API_URL
var service = {
  deposit: (data) => Post(`${apiUrl}wallet/deposit`, data),
  withdrawReceiveAmount: (data) => Post(`${apiUrl}balances/withdraw-receive-amount`, data),
  withdraw: (data) => Post(`${apiUrl}balances/withdraw`, data),
  getWalletTransactionHistory: (page) => Get(`${apiUrl}balances/transaction-history/${page}/10`),
  getBalances: () => Get(`${apiUrl}balances/balance`)
}

export default service
